// partners/partner-plan/PartnerPlan.js
import React, { useCallback, useEffect, useState } from "react";
import PartnerPlanTable from "../../../components/tables/PartnerPlanTable";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { app_url } from "../../../config";
import toast from "react-hot-toast";
import _ from "lodash";
import Error500 from "../../../components/500/Error500";
import PaginationTwo from "../../../components/tables/PaginationTwo";

const PartnerPlan = () => {
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [failed, setFailed] = useState("");
  const [networkIssue, setNetworkIssue] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataOnPage, setDataOnPage] = useState(80);
  const itemsPerPage = dataOnPage;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [search, setSearch] = useState("");

  const fetchPartnerPlan = useCallback(
    _.debounce((search, page) => {
      setLoading(true);
      axios
        .get(
          `${app_url}/api/partner/fetchPartnerPlans?page=${page}&search=${search}&numPerPage=20`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          // if (itemsPerPage > tableData?.data?.pagination?.total_records) {
          //   setCurrentPage(1);
          // }
          setLoading(false);
          setTableData(res);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response) {
            if (err.response.status === 400) {
              toast.error(err.response.data.message || "Bad Request");
            } else if (err.response.status === 401) {
              navigate("/");
            } else if (err.response.status === 500) {
              toast.error(err.response.data.message || "Internal Server Error");
            } else {
              toast.error("An unexpected error occurred.");
            }
          } else {
            setNetworkIssue(true);
            toast.error(
              "Network error. Please check your internet connection."
            );
            setFailed("Network error. Please check your internet connection.");
          }
        });
    }, 500),
    []
  );

  useEffect(() => {
    fetchPartnerPlan(search, currentPage);
  }, [token, dataOnPage, currentPage, search]);

  const searchData = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    setCurrentPage(1);
  };

  // ================= Handle Pagination Page ===================
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (networkIssue) {
    return <Error500 message={failed} />;
  }

  return (
    <div>
      <section className="wrapper">
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-start">
          <div className="d-flex flex-wrap gap-3 justify-content-between">
            <div>
              <p className="heading mb-0">Partner Plan </p>
              <p className="mb-0 text-danger">
                These plans are available exclusively for Partner API services
                and are not accessible via the Partner Portal, as it is
                currently in development.
              </p>
            </div>
            <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center w-100">
              <form autoComplete="off">
                <input
                  style={{ width: 270 }}
                  className="form-control"
                  type="search"
                  placeholder="Search by plan name"
                  aria-label="Search"
                  value={search}
                  onChange={searchData}
                />
              </form>
            </div>
          </div>
          <div className="d-flex">
            <Link
              to={"/partners/partner-plan/add-plan"}
              className="btn card-btn py-2"
            >
              Add Plan
            </Link>
          </div>
        </div>
        <PartnerPlanTable
          tabledata={tableData}
          isLoading={loading}
          fetchPartnerPlan={fetchPartnerPlan}
          search={search}
        />
        <PaginationTwo
          dataOnPage={dataOnPage}
          currentPage={currentPage}
          totalPages={Math.ceil(
            tableData?.data?.pagination?.total_records / itemsPerPage
          )}
          tabledata={tableData}
          onPageChange={handlePageChange}
          indexOfFirstItem={indexOfFirstItem}
          itemsPerPage={itemsPerPage}
          indexOfLastItem={indexOfLastItem}
        />
      </section>
    </div>
  );
};

export default PartnerPlan;
